<p-toast></p-toast>
<div class="container-casosclinicos">
    <h2 style="text-align: center;">Casos clínicos</h2>

    <p-toolbar styleClass="mb-4 gap-2">
        <ng-template pTemplate="left">
            <!-- 
                        <p-fileUpload mode="basic" accept="image/*" [maxFileSize]="1000000" label="Import" chooseLabel="Import"
                            class="mr-2 inline-block"></p-fileUpload>
                        <button pButton pRipple label="Export" icon="pi pi-upload" class="p-button-help"></button>
                        -->
        </ng-template>

        <ng-template pTemplate="right">
            <!--  <button pButton pRipple label="PDF" icon="pi pi-plus" class="p-button-success mr-2" (click)="exportPDF()"></button>-->
            <button pButton pRipple [label]="'Excel'" icon="pi pi-file-excel" class="p-button-success"
                (click)="exportExcel()"></button>

        </ng-template>
    </p-toolbar>

    <div *ngIf="enfermera!==undefined">
        <p-table [value]="casosclinicos" [tableStyle]="{ 'min-width': '50rem' }">
            <ng-template pTemplate="header">
                <tr>
                    <th>Fecha</th>
                    <th>Caso Clinico</th>
                    <th>Paciente</th>
                    <th>Cirugia</th>
                    <th>Hospital</th>
                    <th>status</th>
                    <th>productos/documentos</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-casoclinico>
                <tr>
                    <td>{{casoclinico.fecha | date:'dd/MM/yyyy'}}</td>
                    <td>{{casoclinico.serie}}</td>
                    <td>{{casoclinico.paciente}}</td>
                    <td>{{casoclinico.nomCuerpo}}</td>
                    <td>{{casoclinico.nomHospital}}</td>

                    <td><span
                            [ngClass]="{'solicitud': casoclinico.status_canje === 1,'enproceso': casoclinico.status_canje === 2, 'pagado': casoclinico.status_canje === 3, 'cancelado': casoclinico.status_canje === 4}">
                            {{getCanje(casoclinico.status_canje)}}
                        </span>
                    </td>

                    <td>{{casoclinico.productos.length}} / {{casoclinico.documentos.length}}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                    <td colspan="7">
                        Sin casos clinicos
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="summary">
                <div class="flex align-items-center justify-content-between">
                    No. Registros: {{totalItemsCasosClinicos}}, Total paginas {{totalPaginasCasosClinicos}}
                </div>
            </ng-template>
        </p-table>
        <div class="card flex justify-content-center">
            <p-paginator (onPageChange)="onPageChangeCasosClinicos($event)" [first]="currentPageCasosClinicos.first"
                [rows]="currentPageCasosClinicos.rows" [totalRecords]="totalItemsCasosClinicos"></p-paginator>
        </div>

    </div>
</div>